import type { MentionLinkRequestV1, UnlinkedOccurrenceV1 } from '@codex/contracts';

/** The `mentions.link` body for one occurrence: its own ordinal and the body version it was read at. */
export function mentionLinkBody(item: UnlinkedOccurrenceV1): MentionLinkRequestV1 {
  return {
    sourceDocId: item.sourceDocId,
    blockId: item.blockId,
    occurrence: { ordinal: item.ordinal, baseBodyVersion: item.sourceBodyVersion },
  };
}
